import React from 'react';
import styled, { css } from 'styled-components';

import CheckIcon from '../../svgs/CheckIcon';

export const OptionList = styled.div`
  display: flex;
  gap: 8px;
`;

const OptionItemContainer = styled.div.attrs(
  (props: { isCurrent: boolean; fontSize?: string; isDisabled?: boolean }) =>
    props,
)`
  padding: 16px;
  position: relative;
  border-radius: 8px;
  box-sizing: border-box;
  border: 1px solid transparent;
  cursor: pointer;
  color: var(--foreground);
  flex: 1;
  border: 1px solid var(--border);
  display: flex;
  align-items: center;
  font-size: ${props => props.fontSize || '12px'};
  font-weight: var(--font-weight-bold);
  font-family: var(--font-primary);
  line-height: 18px;
  user-select: none;
  ${props =>
    props.isCurrent &&
    css`
      border-color: var(--primary);
    `}
  ${props =>
    props.isDisabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;

const CheckIconContainer = styled.div.attrs(
  (props: { isCurrent: boolean }) => props,
)`
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 14px;
  right: 16px;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  background: var(--border);
  ${props =>
    props.isCurrent &&
    css`
      background: var(--primary);
    `}
`;

interface OptionItemProps extends React.HTMLAttributes<HTMLDivElement> {
  isCurrent: boolean;
  fontSize?: string;
  disabled?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
}

export function OptionItem({
  isCurrent,
  fontSize,
  disabled = false,
  children,
  onClick,
  ...rest
}: OptionItemProps) {
  return (
    <OptionItemContainer
      isCurrent={isCurrent}
      fontSize={fontSize}
      isDisabled={disabled}
      aria-disabled={disabled || undefined}
      onClick={disabled ? undefined : onClick}
      {...rest}
    >
      {children}
      <CheckIconContainer isCurrent={isCurrent}>
        <CheckIcon fillColor="var(--background)" />
      </CheckIconContainer>
    </OptionItemContainer>
  );
}
